import { createContext, useContext } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { noop } from 'rxjs';
import type { ConversationFormDataType } from '@/components/conversations/conversation-form';
import type { GroupMember } from '@/models/group/group-info';

type ConversationForm = {
  form: UseFormReturn<ConversationFormDataType>;
  canRecord: boolean;
  submit: () => void;
  handleUpdateDraft: () => void;
  isRecorderOpen: boolean;
  toggleRecorderOpen: () => void;
  mentionMemberList: Partial<GroupMember>[];
};

const ConversationFormContext = createContext<ConversationForm | undefined>({
  form: {} as UseFormReturn<ConversationFormDataType>,
  canRecord: false,
  submit: noop,
  handleUpdateDraft: noop,
  isRecorderOpen: false,
  toggleRecorderOpen: noop,
  mentionMemberList: [],
});

export const ConversationFormProvider = ConversationFormContext.Provider;

export default function useConversationForm() {
  const context = useContext(ConversationFormContext);
  if (!context) {
    throw new Error('useConversationForm must be used within a ConversationFormProvider');
  }
  return context;
}
